import React from 'react';
import { GridPattern } from '../common/GridPattern';
import { CartesianAxes } from '../common/CartesianAxes';
import { DraggablePoint } from '../common/DraggablePoint';

export const CyclicQuadrilateralComponent = ({ params, showCoords, onPointDrag, svgRef, viewportWidth = 400, viewportHeight = 300, viewportScale = 1 }) => {
  const { centerX = 200, centerY = 150, radius = 80, angle1 = 40, angle2 = 56, pointP_angle = 45, pointQ_angle = 135, pointR_angle = 225, pointS_angle = 315, showAngles = true, circleColor = "black", strokeWidth = 2 } = params;
  
  const pointP_x = centerX + radius * Math.cos(pointP_angle * Math.PI / 180);
  const pointP_y = centerY + radius * Math.sin(pointP_angle * Math.PI / 180);
  const pointQ_x = centerX + radius * Math.cos(pointQ_angle * Math.PI / 180);
  const pointQ_y = centerY + radius * Math.sin(pointQ_angle * Math.PI / 180);
  const pointR_x = centerX + radius * Math.cos(pointR_angle * Math.PI / 180);
  const pointR_y = centerY + radius * Math.sin(pointR_angle * Math.PI / 180);
  const pointS_x = centerX + radius * Math.cos(pointS_angle * Math.PI / 180);
  const pointS_y = centerY + radius * Math.sin(pointS_angle * Math.PI / 180);
  
  const scaledWidth = viewportWidth * viewportScale;
  const scaledHeight = viewportHeight * viewportScale;
  const viewBox = `0 0 ${scaledWidth} ${scaledHeight}`;
  const displayHeight = Math.max(200, Math.min(800, viewportHeight * viewportScale));
  
  return (
    <svg ref={svgRef} viewBox={viewBox} className="w-full border border-gray-300" style={{ height: `${displayHeight}px` }}>
      <GridPattern viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
      
      <circle 
        cx={centerX} 
        cy={centerY} 
        r={radius} 
        fill="none" 
        stroke={circleColor} 
        strokeWidth={strokeWidth}
      />
      
      <polygon 
        points={`${pointP_x},${pointP_y} ${pointQ_x},${pointQ_y} ${pointR_x},${pointR_y} ${pointS_x},${pointS_y}`}
        fill="none" 
        stroke={circleColor} 
        strokeWidth={strokeWidth}
      />
      
      <line x1={pointP_x} y1={pointP_y} x2={pointR_x} y2={pointR_y} stroke={circleColor} strokeWidth={strokeWidth} strokeDasharray="4,4"/>
      <line x1={pointQ_x} y1={pointQ_y} x2={pointS_x} y2={pointS_y} stroke={circleColor} strokeWidth={strokeWidth} strokeDasharray="4,4"/>
      
      {showAngles && (
        <>
          <text x={pointP_x + 15} y={pointP_y - 10} fontSize="14" fill="red">{angle1}°</text>
          <text x={pointR_x - 25} y={pointR_y + 20} fontSize="14" fill="red">{angle2}°</text>
        </>
      )}
      
      <text x={pointP_x - 5} y={pointP_y - 10} fontSize="16" fontWeight="bold">P</text>
      <text x={pointQ_x - 20} y={pointQ_y - 5} fontSize="16" fontWeight="bold">Q</text>
      <text x={pointR_x - 10} y={pointR_y + 20} fontSize="16" fontWeight="bold">R</text>
      <text x={pointS_x + 10} y={pointS_y + 5} fontSize="16" fontWeight="bold">S</text>
      
      {showCoords && (
        <>
          <DraggablePoint 
            cx={centerX} cy={centerY} 
            label="Center" coords={`(${centerX},${centerY})`}
            onDrag={(x, y) => onPointDrag('centerX', x, 'centerY', y)}
            svgRef={svgRef}
          />
          <DraggablePoint 
            cx={pointP_x} cy={pointP_y} 
            label="P" coords={`(${Math.round(pointP_x)},${Math.round(pointP_y)})`}
            onDrag={(x, y) => {
              const dx = x - centerX;
              const dy = y - centerY;
              const angle = Math.atan2(dy, dx) * 180 / Math.PI;
              onPointDrag('pointP_angle', angle);
            }}
            svgRef={svgRef}
          />
        </>
      )}
      
      <CartesianAxes viewportWidth={viewportWidth} viewportHeight={viewportHeight} viewportScale={viewportScale} />
    </svg>
  );
};

